/* eslint-disable complexity */
import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { PatternLogos } from "@/patterns/wpl/logos/src";

const inlineLogosProp = [
    {
        src: "https://wac-cdn.atlassian.com/misc-assets/svgs/canva-n50.svg",
        alt: "Canva",
        width: "83px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:35c6a74c-a259-4dac-8df8-ea8c5b12f44d/nasa-n50.svg",
        alt: "Nasa",
        width: "52px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:5a1e47e3-be98-4279-a3a2-c626164dbd5d/illumina-n50.svg",
        alt: "Illumina",
        width: "90px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:731482d9-54c4-48e7-a10b-ab601ca4fbd6/docker-n50.svg",
        alt: "Docker",
        width: "95px"
    },
    {
        src: "https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:475f41d8-45f4-48c9-a9b2-d78215ae4b16/nyt-n50.svg",
        alt: "The New York Times",
        width: "145px"
    },
    {
        src: "https://wac-cdn.atlassian.com/misc-assets/svgs/audi-n50.svg",
        alt: "Audi",
        width: "60px"
    }
];

const patternLogosConfluencePageStyle = css({
    "@media (max-width: 29.99rem)": {
        padding: `${token("space.400")} ${token("space.200")} ${token(
            "space.600"
        )}`
    },
    "@media (min-width: 30rem) and (max-width: 47.99rem)": {
        padding: `${token("space.500")} ${token("space.600")} ${token(
            "space.600"
        )}`
    },
    "@media (min-width: 48rem)": {
        padding: `0 0 ${token("space.600")}`
    },
    ".text-section": {
        h2: {
            "fontWeight": 400,
            "textAlign": "center",
            "color": "#091E42",
            "marginTop": 0,
            "fontFamily": "var(--bxp-charlie-text-font-family)",
            "@media (max-width: 63.99rem)": {
                fontSize: "1.125rem",
                lineHeight: "1.625rem"
            },
            "@media (min-width: 64rem)": {
                fontSize: "1.25rem",
                lineHeight: "1.75rem"
            }
        }
    },
    ".row-layout": {
        "width": "100%",
        "padding": 0,
        ".logos-content": {
            "display": "flex",
            "flexWrap": "wrap",
            "gap": "48px",
            "alignItems": "center",
            "justifyContent": "center",
            "maxWidth": "1000px",
            "margin": "auto",
            "@media (max-width: 450px)": {
                maxWidth: "320px"
            },
            "@media (min-width: 720px) and (max-width: 924.99px)": {
                maxWidth: "656px"
            },
            ".logoblock": {
                "margin": "auto 0",
                "+ img": {
                    verticalAlign: "bottom",
                    pointEvents: "none",
                    maxWidth: "100%"
                }
            }
        }
    },
    ".row-layout:last-child": {
        marginBlockStart: token("space.0")
    }
});

const SocialProof = () => {
    const intl = useIntl();
    const patternLogoBodyText = intl.formatMessage({
        id: "ConfluenceSoftwarePageTemplate.socialProofShort.bodyText",
        defaultMessage:
            "75,000+ customers rely on Confluence to share knowledge"
    });

    return (
        <div>
            <PatternLogos
                css={patternLogosConfluencePageStyle}
                inlineLogos={inlineLogosProp}
                headerText={patternLogoBodyText}
            />
        </div>
    );
};

export default SocialProof;
